export default {
  data() {
    return {
      //平台端列表数据
      homeColumnConfig: [
        {
          label: '序号',
          align: 'center',
          prop: 'date',
          fixed: 'left',
          size: 'mini',
          render: (h, scope) => {
            // if (scope.row.sourceType == 2) {
            //   return <span slot="reference"><span style="width: 6px;height: 6px;background: #F14352;border-radius: 7px;display: inline-block"></span>{scope.$index * 1 + 1}</span>
            // } else {
              return <span slot="reference">{scope.$index * 1 + 1}</span>
            // }
          },
        },
        {
          label: '医护类型',
          align: 'center',
          prop: 'doctorType',
          render: (h, scope) => {
            if (scope.row.sourceType == 2) {
              return <span slot="reference"><span style="width: 6px;height: 6px;background: #F14352;border-radius: 7px;display: inline-block"></span>{scope.row.doctorType == 1 ? '医生' : scope.row.doctorType == 2 ? '护士' : scope.row.doctorType == 3 ? '医技' : scope.row.doctorType == 4 ? '药师' : '医辅'}</span>
            } else {
              return <span slot="reference">{scope.row.doctorType == 1 ? '医生' : scope.row.doctorType == 2 ? '护士' : scope.row.doctorType == 3 ? '医技' : scope.row.doctorType == 4 ? '药师' : '医辅'}</span>
            }
            // return <span slot="reference">{scope.row.doctorType == 1 ? '医生' : scope.row.doctorType == 2 ? '护士' : scope.row.doctorType == 3 ? '医技' : scope.row.doctorType == 4 ? '药师' : '医辅'}</span>
          },
        },
        { label: '姓名', align: 'center', prop: 'name', size: 'mini',width: 120 },
        {
          label: '性别',
          align: 'center',
          prop: 'gender',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.gender == '1' ? '男' : scope.row.gender == '2' ? '女' : '未知'}</span>
          },
        },
        {
          label: '年龄',
          align: 'center',
          prop: 'age',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.age ? scope.row.age : '--'}</span>
          },
        },
        {
          label: '手机号',
          align: 'center',
          prop: 'phone',
          size: 'mini',
          width: 120,
        },
        {
          label: '线下机构',
          align: 'center',
          prop: 'hospitalName',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.hospitalName ? scope.row.hospitalName : '--'}</span>
          },
        },
        {
          label: '线下科室',
          align: 'center',
          prop: 'departmentName',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.departmentName ? scope.row.departmentName : '--'}</span>
          },
        },
        
        // {
        //   label: '归属平台',
        //   align: 'center',
        //   prop: 'platformName',
        //   size: 'mini',
        //   render: (h, scope) => {
        //     return <span slot="reference">{scope.row.platformName? scope.row.platformName : '--'}</span>
        //   },
        // },
        // {
        //   label: '归属科室',
        //   align: 'center',
        //   prop: 'platformDepartmentName',
        //   size: 'mini',
        //   render: (h, scope) => {
        //     return <span slot="reference">{scope.row.platformDepartmentName? scope.row.platformDepartmentName : '--'}</span>
        //   },
        // },
        {
          label: '归属团队',
          align: 'center',
          prop: 'joinedTeamName',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.joinedTeamName ? scope.row.joinedTeamName : '--'}</span>
          },
        },
        {
          label: '开通问诊',
          align: 'center',
          prop: 'openInquiry',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.openInquiry ? '是' : '否'}</span>
          },
        },
        {
          label: '提交方式',
          align: 'center',
          prop: 'sourceType',
          size: 'mini',
          render: (h, scope) => {
            return <span>{scope.row.sourceType == 1 ? ' 后台新增' : scope.row.sourceType == 2 ? 'app注册' : '--'}</span>
          },
        },
        {
          label: '提交时间',
          align: 'center',
          prop: 'updateTime',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.updateTime ? scope.row.updateTime : '--'}</span>
          },
        },
        {
          label: '注册时间',
          align: 'center',
          prop: 'registrationTime',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.registrationTime ? scope.row.registrationTime : '--'}</span>
          },
        },
        {
          label: '审核状态',
          align: 'center',
          size: 'mini',
          prop: 'certificateStatus',
          render: (h, scope) => {
            return <span>{scope.row.certificateStatus == 1 ? '待认证' : scope.row.certificateStatus == 2 ? '已提交' : scope.row.certificateStatus == 3 ? '通过' : scope.row.certificateStatus == 4 ? '驳回' : '-'}</span>
          },
        },
        {
          label: '驳回理由',
          align: 'center',
          size: 'mini',
          prop: 'opinion',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.opinion ? scope.row.opinion : '--'}</span>
          },
        },
        {
          label: '状态',
          align: 'center',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.disabled ? '停用' : '启用'}</span>
          },
        },

        // {
        //   label: '是否明星医生',
        //   align: 'center',
        //   render: (h, scope) => {
        //     return <span slot="star">{scope.row.doctorType == 1?scope.row.star==true ? '是' : '否':'--'}</span>
        //   },
        // },


        //       {
        //         label: 'CA签名',
        //         align: 'center',
        //         size: 'mini',
        //         render: (h, scope) => {
        //           return <span>{scope.row.archived ? '有' : '无'}</span>
        //         },
        //       },


        //       {
        //         label: '处方权',
        //         align: 'center',
        //         size: 'mini',
        //         prop: 'prescriptionStatus',
        //         render: (h, scope) => {
        //           return <span slot="reference">{scope.row.prescriptionStatus == 1 ? '未提交' : scope.row.prescriptionStatus == 2 ? '已提交' : scope.row.prescriptionStatus == 3 ? '通过' : scope.row.prescriptionStatus == 4 ? '驳回' : '-'}</span>
        //         },
        //       },
        //       {
        //         label: '审方权',
        //         align: 'center',
        //         size: 'mini',
        //         prop: 'prescriptionApprovalStatus',
        //         render: (h, scope) => {
        //           return <span slot="reference">{scope.row.prescriptionApprovalStatus == 1 ? '未提交' : scope.row.prescriptionApprovalStatus == 2 ? '已提交' : scope.row.prescriptionApprovalStatus == 3 ? '通过' : scope.row.prescriptionApprovalStatus == 4 ? '驳回' : '-'}</span>
        //         },
        //       },

        {
          label: '操作',
          align: 'center',
          fixed: 'right',

          width: '250px',
          render: (h, scope) => {
            return (
              <div>
                {/* <el-button size="mini" type="text" onClick={() =>  this.hometHandel(scope, 'details')}> 查看详情 </el-button>
                <el-button size="mini" type="text" onClick={() =>this.hometHandel(scope, 'switch')}> {scope.row.disabled ? '启用' : '禁用'} </el-button> */}
                {/* <el-button size="mini" type="text" > 资质 </el-button>
                <el-button size="mini" type="text" > 服务 </el-button>
                <el-button size="mini" type="text" > 二维码 </el-button>
                <el-button size="mini" type="text" > 账户 </el-button>
                <el-button size="mini" type="text" > 删除 </el-button> */}
                {/* <el-button size="mini" type="text" v-if="scope.row.doctorType == 1"></el-button> */}
              </div>
            )
          },
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'details')
                    },
                  },
                },
                '详情'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {
                    disabled: scope.row.certificateStatus != 3 ? true : false,
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'switch')
                    },
                  },
                },
                scope.row.disabled ? '启用' : '停用'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { display: scope.row.doctorType != 2 ? 'none' : 'inline-block' },
                  attrs: {
                    disabled: scope.row.doctorType == 2 && !scope.row.disabled && scope.row.certificateStatus == 3 ? false : true,
                  },
                  on: {
                    click: () => {
                      this.servesHandel(scope, 'details')
                    },
                  },
                },
                '服务分配'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { display: scope.row.doctorType == 1 ? 'inline-block' : 'none' },
                  attrs: {

                  },
                  on: {
                    click: () => {
                      this.setDoctor(scope.row)
                    },
                  },
                },
                scope.row.star ? '取消推荐' : '佳一推荐'
              ),
            ])
          },
        },
      ],
      //结构端列表数据
      homeColumnConfig1: [
        {
          label: '序号',
          align: 'center',
          prop: 'date',
          fixed: 'left',
          size: 'mini',
          render: (h, scope) => {
            // if (scope.row.sourceType == 2) {
            //   return <span slot="reference"><span style="width: 6px;height: 6px;background: #F14352;border-radius: 7px;display: inline-block"></span>{scope.$index * 1 + 1}</span>
            // } else {
              return <span slot="reference">{scope.$index * 1 + 1}</span>
            // }
          },
        },
        {
          label: '医护类型',
          align: 'center',
          prop: 'doctorType',
          render: (h, scope) => {
            if (scope.row.sourceType == 2) {
              return <span slot="reference"><span style="width: 6px;height: 6px;background: #F14352;border-radius: 7px;display: inline-block"></span>{scope.row.doctorType == 1 ? '医生' : scope.row.doctorType == 2 ? '护士' : scope.row.doctorType == 3 ? '医技' : scope.row.doctorType == 4 ? '药师' : '医辅'}</span>
            } else {
              return <span slot="reference">{scope.row.doctorType == 1 ? '医生' : scope.row.doctorType == 2 ? '护士' : scope.row.doctorType == 3 ? '医技' : scope.row.doctorType == 4 ? '药师' : '医辅'}</span>
            }
          },
        },
        { label: '姓名', align: 'center', prop: 'name', size: 'mini',width: 120 },
        {
          label: '性别',
          align: 'center',
          prop: 'gender',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.gender == '1' ? '男' : scope.row.gender == '2' ? '女' : '未知'}</span>
          },
        },
        {
          label: '年龄',
          align: 'center',
          prop: 'age',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.age ? scope.row.age : '--'}</span>
          },
        },
        {
          label: '手机号',
          align: 'center',
          prop: 'phone',
          size: 'mini',
        },
        {
          label: '线下科室',
          align: 'center',
          prop: 'departmentName',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.departmentName ? scope.row.departmentName : '--'}</span>
          },
        },
        //   {
        //     label: '线下机构',
        //     align: 'center',
        //     prop: 'hospitalName',
        //     size: 'mini',
        // render: (h, scope) => {
        //   return <span slot="reference">{scope.row.hospitalName? scope.row.hospitalName : '--'}</span>
        // },
        //   },
        // {
        //   label: '归属平台',
        //   align: 'center',
        //   prop: 'platformName',
        //   size: 'mini',
        //   render: (h, scope) => {
        //     return <span slot="reference">{scope.row.platformName? scope.row.platformName : '--'}</span>
        //   },
        // },
        // {
        //   label: '归属科室',
        //   align: 'center',
        //   prop: 'platformDepartmentName',
        //   size: 'mini',
        //   render: (h, scope) => {
        //     return <span slot="reference">{scope.row.platformDepartmentName? scope.row.platformDepartmentName : '--'}</span>
        //   },
        // },
        {
          label: '归属团队',
          align: 'center',
          prop: 'joinedTeamName',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.joinedTeamName ? scope.row.joinedTeamName : '--'}</span>
          },
        },
        {
          label: '开通问诊',
          align: 'center',
          prop: 'openInquiry',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.openInquiry ? "是" : '否'}</span>
          },
        },
        {
          label: '提交方式',
          align: 'center',
          prop: 'sourceType',
          size: 'mini',
          render: (h, scope) => {
            return <span>{scope.row.sourceType == 1 ? ' 后台新增' : scope.row.sourceType == 2 ? 'app注册' : '--'}</span>
          },
        },
        {
          label: '提交时间',
          align: 'center',
          prop: 'updateTime',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.updateTime ? scope.row.updateTime : '--'}</span>
          },
        },
        {
          label: '注册时间',
          align: 'center',
          prop: 'registrationTime',
          size: 'mini',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.registrationTime ? scope.row.registrationTime : '--'}</span>
          },
        },
        {
          label: '审核状态',
          align: 'center',
          size: 'mini',
          prop: 'certificateStatus',
          render: (h, scope) => {
            return <span>{scope.row.certificateStatus == 1 ? '未提交' : scope.row.certificateStatus == 2 ? '已提交' : scope.row.certificateStatus == 3 ? '通过' : scope.row.certificateStatus == 4 ? '驳回' : '-'}</span>
          },
        },
        {
          label: '驳回理由',
          align: 'center',
          size: 'mini',
          prop: 'opinion',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.opinion ? scope.row.opinion : '--'}</span>
          },
        },
        {
          label: '状态',
          align: 'center',
          render: (h, scope) => {
            return <span slot="reference">{scope.row.disabled ? '停用' : '启用'}</span>
          },
        },

        // {
        //   label: '是否明星医生',
        //   align: 'center',
        //   render: (h, scope) => {
        //     return <span slot="star">{scope.row.doctorType == 1?scope.row.star==true ? '是' : '否':'--'}</span>
        //   },
        // },


        //       {
        //         label: 'CA签名',
        //         align: 'center',
        //         size: 'mini',
        //         render: (h, scope) => {
        //           return <span>{scope.row.archived ? '有' : '无'}</span>
        //         },
        //       },


        //       {
        //         label: '处方权',
        //         align: 'center',
        //         size: 'mini',
        //         prop: 'prescriptionStatus',
        //         render: (h, scope) => {
        //           return <span slot="reference">{scope.row.prescriptionStatus == 1 ? '未提交' : scope.row.prescriptionStatus == 2 ? '已提交' : scope.row.prescriptionStatus == 3 ? '通过' : scope.row.prescriptionStatus == 4 ? '驳回' : '-'}</span>
        //         },
        //       },
        //       {
        //         label: '审方权',
        //         align: 'center',
        //         size: 'mini',
        //         prop: 'prescriptionApprovalStatus',
        //         render: (h, scope) => {
        //           return <span slot="reference">{scope.row.prescriptionApprovalStatus == 1 ? '未提交' : scope.row.prescriptionApprovalStatus == 2 ? '已提交' : scope.row.prescriptionApprovalStatus == 3 ? '通过' : scope.row.prescriptionApprovalStatus == 4 ? '驳回' : '-'}</span>
        //         },
        //       },

        {
          label: '操作',
          align: 'center',
          fixed: 'right',

          width: '250px',
          render: (h, scope) => {
            return (
              <div>
                {/* <el-button size="mini" type="text" onClick={() =>  this.hometHandel(scope, 'details')}> 查看详情 </el-button>
                <el-button size="mini" type="text" onClick={() =>this.hometHandel(scope, 'switch')}> {scope.row.disabled ? '启用' : '禁用'} </el-button> */}
                {/* <el-button size="mini" type="text" > 资质 </el-button>
                <el-button size="mini" type="text" > 服务 </el-button>
                <el-button size="mini" type="text" > 二维码 </el-button>
                <el-button size="mini" type="text" > 账户 </el-button>
                <el-button size="mini" type="text" > 删除 </el-button> */}
                {/* <el-button size="mini" type="text" v-if="scope.row.doctorType == 1"></el-button> */}
              </div>
            )
          },
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'details')
                    },
                  },
                },
                '详情'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {
                    disabled: scope.row.certificateStatus != 3 ? true : false,
                  },
                  on: {
                    click: () => {
                      this.hometHandel(scope, 'switch')
                    },
                  },
                },
                scope.row.disabled ? '启用' : '停用'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { display: scope.row.doctorType != 2 ? 'none' : 'inline-block' },
                  attrs: {
                    disabled: scope.row.doctorType == 2 && !scope.row.disabled && scope.row.certificateStatus == 3 ? false : true,
                  },
                  on: {
                    click: () => {
                      this.servesHandel(scope, 'details')
                    },
                  },
                },
                '服务分配'
              ),
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  style: { display: scope.row.doctorType == 1 ? 'inline-block' : 'none' },
                  attrs: {

                  },
                  on: {
                    click: () => {
                      this.setDoctor(scope.row, 1)
                    },
                  },
                },
                scope.row.recommendInHospital ? '取消推荐' : '院内推荐'
              ),
            ])
          },
        },
      ],
      buttonList: [

        //       {
        //         name: '账号启用：',
        //         module: 'disabledList',
        //         list: [
        //           {
        //             value: false,
        //             name: '启用',
        //           },
        //           {
        //             value: true,
        //             name: '停用',
        //           },
        //         ],
        //       },
        //       {
        //         name: '互医服务：',
        //         module: 'openInternetInquiryList',
        //         list: [
        //           {
        //             value: true,
        //             name: '开通',
        //           },
        //           {
        //             value: false,
        //             name: '无',
        //           },
        //         ],
        //       },
        //       {
        //         name: '开放预约：',
        //         module: 'appointmentList',
        //         list: [
        //           {
        //             value: true,
        //             name: '开放',
        //           },
        //           {
        //             value: false,
        //             name: '未开放',
        //           },
        //         ],
        //       },
        //       {
        //         name: '全病程服务：',
        //         module: 'openWholeTreatmentList',
        //         list: [
        //           {
        //             value: true,
        //             name: '是',
        //           },
        //           {
        //             value: false,
        //             name: '否',
        //           },
        //         ],
        //       },
        //       {
        //         name: '置顶推荐：',
        //         module: 'recommendList',
        //         list: [
        //           {
        //             value: true,
        //             name: '推荐',
        //           },
        //           {
        //             value: false,
        //             name: '未推荐',
        //           },
        //         ],
        //       },
        //       {
        //         name: '资质审核：',
        //         module: 'certificateStatus',
        //         list: [
        //           {
        //             value: true,
        //             name: '有',
        //           },
        //           {
        //             value: false,
        //             name: '无',
        //           },
        //         ],
        //       },
        //       {
        //         name: 'CA签名：',
        //         module: 'archivedList',
        //         list: [
        //           {
        //             value: true,
        //             name: '有',
        //           },
        //           {
        //             value: false,
        //             name: '无',
        //           },
        //         ],
        //       },
        //       {
        //         name: '处方权：',
        //         module: 'prescriptionStatus',
        //         list: [
        //           {
        //             value: true,
        //             name: '有',
        //           },
        //           {
        //             value: false,
        //             name: '无',
        //           },
        //         ],
        //       },
        //       {
        //         name: '审方权：',
        //         module: 'prescriptionApprovalStatus',
        //         list: [
        //           {
        //             value: true,
        //             name: '有',
        //           },
        //           {
        //             value: false,
        //             name: '无',
        //           },
        //         ],
        //       },
        // {
        //   name: '明星医生：',
        //   module: 'starList',
        //   list: [
        //     {
        //       value: 1,
        //       name: '是',
        //     },
        //     {
        //       value: 0,
        //       name: '否',
        //     },
        //   ],
        // },
        // {
        //   name: '明星医生：',
        //   module: 'starList',
        //   list: [
        //     {
        //       value: true,
        //       name: '是',
        //     },
        //     {
        //       value: false,
        //       name: '否',
        //     },
        //   ],
        // },
      ],
      TimeeColumnConfig: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index + 1}</span>
          },
        },
        { label: '团队ID', align: 'center', prop: 'doctorTeamId' },
        {
          label: '团队名称',
          align: 'center',
          prop: 'teamName',
        },
        {
          label: '身份',
          align: 'center',
          prop: 'leader',
          render: (h, scope) => {
            return <span slot="reference">{scope.leader ? '领衔专家' : '成员'}</span>
          },
        },
        {
          label: '操作',
          align: 'center',
          width: 100,
          fixed: 'right',
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {//只读状态 禁用按钮
                    disabled: this.isEdit ? true : false,
                  },
                  on: {
                    click: () => {
                      this.resetHandel(scope, 'remove')
                    },
                  },
                },
                '删除'
              ),
            ])
          },
          // render: (h, scope) => {
          //   return (
          //     <div slot="reference">
          //       {/* /*<el-button size="mini" type="text" onClick={()=>
          //                           this.resetHandel(scope,'reset')
          //                       }>管理</el-button>*/}
          //       <el-button size="mini" type="text" onClick={() => this.resetHandel(scope, 'remove')}>
          //         移除
          //       </el-button>
          //     </div>
          //   )
          // },
        },
      ],
      platformConfog: [
        {
          label: '序号',
          align: 'center',
          fixed: 'left',
          render: (h, scope) => {
            return <span slot="reference">{scope.$index + 1}</span>
          },
        },
        {
          label: '互医平台',
          align: 'center',
          prop: 'platformName'
        },
        {
          label: '互医科室',
          align: 'center',
          prop: 'platformDepartmentName'
        },
        {
          label: '操作',
          align: 'center',
          render: (h, scope) => {
            return h('div', [
              h(
                'el-button',
                {
                  props: { type: 'text', size: 'mini' },
                  attrs: {//只读状态 禁用按钮
                    disabled: this.isEdit ? true : false,
                  },
                  on: {
                    click: () => {
                      this.platformDelect(scope)
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },

      ],
      idCartOptions: [
        {
          value: '1',
          label: '通过',
        },
        {
          value: '2',
          label: '拒绝',
        },
      ],
      incomeColumnConfig: [
        {
          label: '序号',
          align: 'center',
          prop: 'id',
          fixed: 'left',
          resizable: false,
        },
        {
          label: '时间',
          align: 'center',
          prop: 'id1',
          fixed: 'left',
        },
        {
          label: '类型',
          align: 'center',
          prop: 'id2',
          fixed: 'left',
        },
        {
          label: '金额',
          align: 'center',
          prop: 'id3',
          fixed: 'left',
        },
        {
          label: '余额',
          align: 'center',
          prop: 'id4',
          fixed: 'left',
        },
        {
          label: '说明',
          align: 'center',
          prop: 'id5',
          fixed: 'left',
        },
      ],
      idCarButtonList: [
        {
          name: '通过',
          id: 1,
          clickHandel: this.submitIdCart,
        },
        {
          name: '驳回',
          id: 2,
          clickHandel: this.submitIdCart,
        },
        {
          name: '清除',
          id: 3,
          clickHandel: this.submitIdCart,
        },
        {
          name: '提交',
          id: 4,
          clickHandel: this.submitIdCart,
        },
      ],
      certificateQualificationButtonList: [
        {
          name: '通过',
          id: 1,
          clickHandel: this.submitCertificateQualification,
        },
        {
          name: '驳回',
          id: 2,
          clickHandel: this.submitCertificateQualification,
        },
        {
          name: '清除',
          id: 3,
          clickHandel: this.submitCertificateQualification,
        },
        {
          name: '提交',
          id: 4,
          clickHandel: this.submitCertificateQualification,
        },
      ],
      certificatePracticeButtonList: [
        {
          name: '通过',
          id: 1,
          clickHandel: this.submitCertificatePractice,
        },
        {
          name: '驳回',
          id: 2,
          clickHandel: this.submitCertificatePractice,
        },
        {
          name: '清除',
          id: 3,
          clickHandel: this.submitCertificatePractice,
        },
        {
          name: '提交',
          id: 4,
          clickHandel: this.submitCertificatePractice,
        },
      ],
      certificateTitleButtonList: [
        {
          name: '通过',
          id: 1,
          clickHandel: this.submitCertificateTitle,
        },
        {
          name: '驳回',
          id: 2,
          clickHandel: this.submitCertificateTitle,
        },
        {
          name: '清除',
          id: 3,
          clickHandel: this.submitCertificateTitle,
        },
        {
          name: '提交',
          id: 4,
          clickHandel: this.submitCertificateTitle,
        },
      ],
      certificateMultiSitePracticeButtonList: [
        {
          name: '通过',
          id: 1,
          clickHandel: this.submitCertificateMultiSitePractice,
        },
        {
          name: '驳回',
          id: 2,
          clickHandel: this.submitCertificateMultiSitePractice,
        },
        {
          name: '清除',
          id: 3,
          clickHandel: this.submitCertificateMultiSitePractice,
        },
        {
          name: '提交',
          id: 4,
          clickHandel: this.submitCertificateMultiSitePractice,
        },
      ],
      certificateEmploymentContractListButtonList: [
        {
          name: '通过',
          id: 1,
          clickHandel: this.submitCertificateEmploymentContractList,
        },
        {
          name: '驳回',
          id: 2,
          clickHandel: this.submitCertificateEmploymentContractList,
        },
        {
          name: '清除',
          id: 3,
          clickHandel: this.submitCertificateEmploymentContractList,
        },
        {
          name: '提交',
          id: 4,
          clickHandel: this.submitCertificateEmploymentContractList,
        },
      ],
      doctorTypeList: [
        {
          value: '1',
          label: '医生',
        },
        {
          value: '2',
          label: '护士',
        },
        // {
        //   value: '3',
        //   label: '医技',
        // },
        {
          value: '4',
          label: '药师',
        },
        {
          value: '6',
          label: '医辅'
        }
      ],
      idCardTypeList: [
        {
          value: '1',
          label: '身份证',
        },
        {
          value: '2',
          label: '军官证',
        },
      ],
      typesOfIncomeList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '收入',
        },
        {
          value: '2',
          label: '提取',
        },
      ],
    }
  },
}
